// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jbEY","left":"styles_left__LS9r-"};